/*
 * 商品列表配置
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 19:44:23
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-09-06 16:54:29
 */

const api = {
	//编辑&新增
	saveCommodity: '/commodity/saveCommodity', //新增商品
	updateCommodity: '/commodity/updateCommodity', //编辑商品
	listCategories: '/commodity/category/listCategories',  //列出商品类目
	listSections: '/section/listSections',  //列出商品分类
	listProperties: '/property/listProperties', //商品属性查询
	listStalls: '/stall/listStallNames',  //查询档口列表
	//列表页
	listCommodities: '/commodity/listCommodities', //商品列表
	storeDetail: '/store/detail', //店铺详情
	deleteCommodities: '/commodity/deleteCommodities', //批量删除商品
	publish: '/commodity/publish', //商品上架
	takeOff: '/commodity/takeOff', //商品下架
	//商品详情页
	commodityDetail: '/commodity/findCommodityDetailByStoreManager', //商品详情
	downloadCommodityQrcode: '/commodity/downloadCommodityQrcode', //下载商品推广二维码
	setStocks: '/stock/setStocks', //设置库存
};

// 与路由对应的面包屑名称
const routes = {
	'/commodity-list': '商品列表',
	'/commodity-list/add': '新增商品',
	'/commodity-list/detail': '商品详情',
	'/commodity-list/edit': '编辑商品',
	'/commodity-list/qrCode': '商品二维码',
	'/commodity-list/applyList': '审核列表',
	'/commodity-list/applyList/detail': '申请详情',
	'/commodity-list/applyList/edit': '编辑'
};

export {
	api,
	routes,
};
